(() => {
  const dialog = document.querySelector('#sb-fenvie-cart');
  const form = document.querySelector('#fenvie-product-form');
  const configElement = document.querySelector('#sb-fenvie-cart-config');
  if (!dialog || !form || !configElement || !window.fetch || !dialog.showModal) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  if (!Array.isArray(config.variants) || !config.cartUrl?.startsWith('/')) return;
  const cartUrl = config.cartUrl.replace(/\/$/, '');
  const $ = selector => dialog.querySelector(selector);
  const variantFor = id => config.variants.find(variant => String(variant.id) === String(id));
  const isFenvie = line => String(line.product_id) === String(config.productId) && !!variantFor(line.variant_id);
  const properties = line => line.properties || {};
  const plan = line => line.selling_plan_allocation?.selling_plan?.id || null;
  const identity = line => JSON.stringify([String(line.variant_id), Object.entries(properties(line)).sort(([a], [b]) => a.localeCompare(b)), plan(line)]);
  const ordinary = line => !line.parent_relationship && !line.item_components?.length && !line.has_components && !line.nested_line_parent && !cart?.items.some(child => child.parent_relationship?.parent_key === line.key);
  const eligible = variant => form.dataset.commerceReady === 'true' && variant.available && variant.price === 4495 && variant.compare_at_price === 8990 && ['FENVIE-GO-BLACK', 'FENVIE-GO-WHITE', 'FENVIE-GO-PINK'].includes(variant.sku) && config.variants.filter(choice => choice.sku === variant.sku).length === 1;
  let cart = null;
  let busy = false;
  let unresolved = false;
  let opener = null;
  const ready = () => getComputedStyle(dialog).getPropertyValue('--cart-plum').trim() !== '';
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cart.currency }).format(amount / 100);

  function controls() {
    dialog.setAttribute('aria-busy', String(busy));
    dialog.querySelectorAll('[data-line-plus],[data-line-minus],[data-line-remove],[data-line-colour]').forEach(control => {
      control.disabled = busy || !cart || control.dataset.locked === 'true';
    });
    $('[data-cart-refresh]').disabled = busy;
    $('[data-cart-checkout]').disabled = busy || !cart?.item_count;
    document.querySelectorAll('button[form="fenvie-product-form"]').forEach(button => {
      button.disabled = busy || unresolved || form.dataset.commerceReady !== 'true' || form.dataset.variantReady !== 'true';
      button.setAttribute('aria-disabled', String(button.disabled));
    });
  }

  function showError(message, refresh = false) {
    $('[data-cart-error]').textContent = message;
    $('[data-cart-error]').hidden = !message;
    $('[data-cart-refresh]').hidden = !refresh;
  }

  function open(source) {
    if (!dialog.open) {
      opener = source instanceof HTMLElement ? source : document.activeElement;
      sizeDialog();
      dialog.showModal();
      document.documentElement.classList.add('sb-fenvie-cart-visible');
    }
  }

  function sizeDialog() {
    // The existing desktop PDP scales body at three breakpoints; keep its modal full-height.
    dialog.style.zoom = String(1 / (parseFloat(getComputedStyle(document.body).zoom) || 1));
  }
  window.addEventListener('resize', () => { if (dialog.open) sizeDialog(); });

  async function request(path, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(cartUrl + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { Accept: 'application/json', ...(body && !(body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {}),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify could not save that change.');
      return data;
    } finally { clearTimeout(timeout); }
  }

  async function read() {
    const data = await request('.js');
    if (!Array.isArray(data.items) || !Number.isFinite(data.total_price) || !data.currency || !Number.isFinite(data.item_count)) throw new Error('We could not read your bag.');
    cart = data;
    unresolved = false;
    render();
    return data;
  }

  function render() {
    const fragment = document.createDocumentFragment();
    let compareSavings = 0;
    for (const line of cart.items) {
      const node = $('[data-cart-line-template]').content.firstElementChild.cloneNode(true);
      const field = selector => node.querySelector(selector);
      const fenvie = isFenvie(line);
      const variant = fenvie ? variantFor(line.variant_id) : null;
      node.dataset.lineKey = line.key;
      field('[data-line-title]').textContent = fenvie ? 'Fenvie Go' : line.product_title || line.title;
      field('[data-line-subtitle]').textContent = fenvie ? 'Portable heated styling brush' : line.variant_title === 'Default Title' ? '' : line.variant_title || '';
      const image = field('[data-line-image]');
      image.alt = line.featured_image?.alt || line.product_title || line.title || '';
      const source = line.featured_image?.url || line.image;
      try {
        const url = new URL(source, location.origin);
        if (!source || !['https:', 'http:'].includes(url.protocol)) throw new Error();
        url.searchParams.set('width', '216');
        image.src = url.href;
      } catch { image.hidden = true; }
      const details = Object.entries(properties(line)).filter(([key, value]) => !key.startsWith('_') && value !== '' && value != null).map(([key, value]) => `${key}: ${value}`);
      if (line.selling_plan_allocation?.selling_plan?.name) details.push(line.selling_plan_allocation.selling_plan.name);
      field('[data-line-properties]').textContent = details.join('\n');
      field('[data-line-properties]').hidden = !details.length;
      field('[data-line-price]').textContent = money(line.final_line_price);
      const comparable = variant && cart.currency === config.currency && Number.isFinite(variant.compare_at_price) && Number.isFinite(variant.price);
      const compare = comparable ? variant.compare_at_price * line.quantity : 0;
      if (compare > line.final_line_price) {
        field('[data-line-compare]').textContent = money(compare);
        field('[data-line-compare]').hidden = false;
        compareSavings += Math.max(0, compare - line.original_line_price);
      }
      const colour = field('[data-line-colour]');
      if (fenvie) {
        field('[data-line-colour-label]').hidden = false;
        for (const choice of config.variants) {
          const option = document.createElement('option');
          option.value = String(choice.id);
          option.textContent = choice.public_title || choice.title;
          option.disabled = !eligible(choice);
          if (!choice.available) option.textContent += ' — sold out';
          else if (!eligible(choice)) option.textContent += ' — unavailable';
          colour.append(option);
        }
        colour.value = String(line.variant_id);
        colour.dataset.locked = String(!ordinary(line) || !!plan(line) || form.dataset.commerceReady !== 'true');
        field('[data-line-dot]').style.background = { 'FENVIE-GO-BLACK': '#27242a', 'FENVIE-GO-WHITE': '#f1ece4', 'FENVIE-GO-PINK': '#e6c3d0' }[variant.sku] || '#ddd';
        colour.addEventListener('change', () => swapColour(line, colour.value));
      }
      field('[data-line-quantity]').textContent = String(line.quantity);
      for (const [selector, quantity] of [['[data-line-minus]', line.quantity - 1], ['[data-line-plus]', line.quantity + 1], ['[data-line-remove]', 0]]) {
        const button = field(selector);
        button.dataset.locked = String(!ordinary(line));
        button.addEventListener('click', () => mutate(async () => {
          await request('/change.js', { id: line.key, quantity });
        }, quantity === 0 ? 'Item removed.' : 'Quantity updated.'));
      }
      fragment.append(node);
    }
    $('[data-cart-lines]').replaceChildren(fragment);
    const allFenvie = cart.items.length > 0 && cart.items.every(isFenvie);
    $('[data-cart-empty]').hidden = cart.item_count !== 0;
    $('[data-cart-gifts]').hidden = !cart.items.some(isFenvie);
    $('[data-cart-shipping-row]').hidden = !allFenvie;
    $('[data-cart-trial]').hidden = !allFenvie;
    $('[data-cart-delivery]').textContent = allFenvie ? 'Estimated delivery: 2–10 working days.' : 'Shipping calculated at checkout.';
    $('[data-cart-count]').textContent = String(cart.item_count);
    document.querySelectorAll('[data-fenvie-bag-count]').forEach(count => { count.textContent = String(cart.item_count); });
    $('[data-cart-subtotal]').textContent = money(cart.total_price);
    const savings = compareSavings + Math.max(0, cart.original_total_price - cart.total_price);
    $('[data-cart-savings]').textContent = money(savings);
    $('[data-cart-savings-row]').hidden = !(savings > 0);
    controls();
  }

  // One in-flight cart operation per page; Shopify remains authoritative across tabs.
  async function mutate(operation, success) {
    if (busy) return;
    const focused = document.activeElement;
    const focusKey = focused?.closest('[data-line-key]')?.dataset.lineKey;
    const focusAttribute = ['data-line-plus', 'data-line-minus', 'data-line-colour', 'data-line-remove'].find(attribute => focused?.hasAttribute(attribute));
    busy = true;
    unresolved = true;
    showError('');
    $('[data-cart-status]').textContent = 'Updating your bag…';
    controls();
    try {
      await operation();
      await read();
      $('[data-cart-status]').textContent = success;
    } catch (error) {
      // A failed add (including 422) may still have saved stock. Never repeat a POST.
      cart = null;
      unresolved = true;
      try {
        await read();
        showError(`${error.message || 'The update could not be confirmed.'} Your current bag is shown below. Check its items and quantities before checkout.`);
      } catch {
        showError('We could not confirm your bag. Refresh it to check what was saved before trying another change.', true);
      }
      $('[data-cart-status]').textContent = '';
    } finally {
      busy = false;
      controls();
      if (dialog.open && focusKey && focusAttribute) {
        const replacement = [...dialog.querySelectorAll('[data-line-key]')].find(node => node.dataset.lineKey === focusKey);
        (replacement?.querySelector(`[${focusAttribute}]`) || $('[data-cart-close]')).focus();
      }
    }
  }

  async function refresh(source) {
    open(source);
    if (busy) return;
    busy = true;
    cart = null;
    showError('');
    $('[data-cart-status]').textContent = 'Loading your bag…';
    controls();
    try { await read(); $('[data-cart-status]').textContent = ''; }
    catch { showError('Your bag could not be loaded. Please try Refresh bag.', true); $('[data-cart-status]').textContent = ''; }
    finally { busy = false; controls(); }
  }

  function swapColour(source, id) {
    if (busy || String(source.variant_id) === id) return;
    const variant = variantFor(id);
    if (!variant || !eligible(variant) || !ordinary(source) || plan(source)) { render(); return; }
    mutate(async () => {
      const originalIdentity = identity(source);
      const originalQuantity = source.quantity;
      const fresh = await read();
      const matches = fresh.items.filter(line => identity(line) === originalIdentity);
      if (matches.length !== 1 || matches[0].quantity !== originalQuantity || !ordinary(matches[0])) throw new Error('Your bag changed. Choose the colour again after checking it.');
      const targetIdentity = identity({ variant_id: variant.id, properties: properties(source) });
      const targets = fresh.items.filter(line => identity(line) === targetIdentity);
      if (targets.some(line => !ordinary(line))) throw new Error('This colour is part of a bundle. Use the full bag to make changes.');
      const expectedQuantity = originalQuantity + targets.reduce((sum, line) => sum + line.quantity, 0);
      await request('/add.js', { items: [{ id: variant.id, quantity: originalQuantity, properties: properties(source) }] });
      const added = await read();
      const saved = added.items.filter(line => identity(line) === targetIdentity);
      if (saved.some(line => !ordinary(line)) || saved.reduce((sum, line) => sum + line.quantity, 0) !== expectedQuantity) throw new Error('The new colour could not be confirmed. Your previous colour has been kept.');
      const remaining = added.items.filter(line => identity(line) === originalIdentity);
      if (remaining.length !== 1 || remaining[0].quantity !== originalQuantity || !ordinary(remaining[0])) throw new Error('The new colour was added, but the previous colour could not be safely removed. Remove any item you do not want.');
      try { await request('/change.js', { id: remaining[0].key, quantity: 0 }); }
      catch { throw new Error('The colour change could not be fully confirmed. Remove any colour you do not want.'); }
    }, 'Colour updated.');
  }

  form.addEventListener('submit', event => {
    if (busy || unresolved) { event.preventDefault(); if (!busy) refresh(event.submitter); return; }
    if (event.defaultPrevented || !ready() || form.dataset.commerceReady !== 'true' || form.dataset.variantReady !== 'true') return;
    const data = new FormData(form);
    event.preventDefault();
    data.delete('return_to');
    open(event.submitter);
    mutate(() => request('/add.js', data), 'Added to your bag.');
  });
  document.querySelectorAll('[data-fenvie-cart-open]').forEach(link => link.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !ready()) return;
    event.preventDefault();
    refresh(link);
  }));
  $('[data-cart-refresh]').addEventListener('click', event => refresh(event.currentTarget));
  $('[data-cart-checkout-form]').addEventListener('submit', event => {
    if (busy || !cart?.item_count) event.preventDefault();
  });
  dialog.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('sb-fenvie-cart-visible');
    if (opener?.isConnected) opener.focus();
  });
})();
